import { useQuery } from "@tanstack/react-query";
import { API_POP_UP } from "../apis";
import { QUERY_KEY } from "../keys";

export const useGetPopUp = <T>() => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_POP_UP_INFO],
        queryFn: () => API_POP_UP.getPopUpInfo<T>(),
    });

    return { data, isLoading };
};
